import { ChevronLeft, ChevronRight, MenuBook } from '@mui/icons-material'
import { FC, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { Box, Button, Pagination, Typography } from '@mui/material'
import { useGET_goalProgressionQuery } from 'redux/api/goalbankApi'
import { useNavigate } from 'react-router-dom'
import { useGET_groupCourseSelectQuery } from 'redux/api/groupCoursesApi'
import SelectField from 'components/atoms/fields/SelectField'
import { Form, Formik } from 'formik'
import { useMedia } from 'utils/customHooks/useMedia'
import BoxTitle from 'components/atoms/BoxTitle'



const LearningProgression: FC = () => {
  const { t } = useTranslation()  
  const navigate = useNavigate()
  const { windowWidth, isUnder600px } = useMedia()

  const PAGE_SIZE = 5
  const LABEL_WIDTH = isUnder600px ? Math.round(windowWidth/2)-40 : 300
  const CELL_WIDTH = isUnder600px ? Math.round(windowWidth/2)-40 : 280

  const [page, setPage] = useState(1)
  const [scroll, setScroll] = useState(0)
  const [groupCourse, setGroupCourse] = useState(null)
  
  const { data } = useGET_goalProgressionQuery(groupCourse,{skip: !groupCourse})
  
  const scrollLeft = () => {
    let newScroll = scroll - CELL_WIDTH;
    newScroll = newScroll > 0 ? newScroll : 0
    setScroll(newScroll)
  }

  const scrollRight = () => {
    const maxScroll = data && data.students ? (data.students.length-1)*CELL_WIDTH : 0
    let newScroll = scroll + CELL_WIDTH;
    newScroll = newScroll < maxScroll ? newScroll : maxScroll
    setScroll(newScroll) 
  }

  const levelColor = (percentage) => {
    let id="in-progress";
    if(percentage>90)id="mastered";
    else if(percentage>80)id="satisfactory";
    else if(percentage>70)id="can-do-better";
    else if(percentage>0)id="need-attention"
    return levels.find(level => level.id === id).color
  }

  const levels = [
    {id: 'mastered', label: t('learning-progression-types.mastered'), color: '#69d59b'},
    {id: 'satisfactory', label: t('learning-progression-types.satisfactory'), color: '#ffc543'},
    {id: 'can-do-better', label: t('learning-progression-types.can-do-better'), color: '#ee7532'},
    {id: 'need-attention', label: t('learning-progression-types.need-attention'), color: '#f1465a'},
    {id: 'in-progress', label: t('learning-progression-types.in-progress'), color: '#cacad8'},
  ]
  
  return (
     <Box className="thick-border dashboard-rti">

        <div style={{ display: 'flex', width: '100%', marginBottom: '40px', gap: '10px' }}>
            <div>
              <div><BoxTitle title={t('common.grading')} icon={<MenuBook />} /></div>
              <div style={{ fontSize: '16px' }}>{t('common.learning-progression')}</div>
            </div>
            <div style={{ marginLeft: 'auto'}}>
                <Button size='small'  variant='contained' color='primary' onClick={() => {navigate('/grades')}}>
                   <Typography sx={{fontSize:'11px',fontWeight:'600'}}>{`${t('common.gradebook-grid')}`}</Typography>
                </Button> &nbsp; 
                <Button size='small'  variant='contained' color='primary' onClick={() => {navigate('/rubrics')}} >
                  <Typography sx={{fontSize:'11px',fontWeight:'600'}}>{`${t('common.rubrics')}`}</Typography>
                </Button>
            </div>
        </div>

        <div className="learning-progression-head">
          <div style={{ width: '280px', paddingRight: '40px' }}>
            <Formik 
              initialValues={{ group_course: null }} 
              validationSchema={null} 
              onSubmit={(values)=>{}}>
              <Form style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }}>
                <SelectField
                  fieldProps={{ label: t('common.my-courses'), name: 'group_course' }}
                  apiCall={useGET_groupCourseSelectQuery}
                  onChange={(value: { id: any }) => {
                      setGroupCourse(value?.id ?? null)
                  }}
                />
              </Form>
            </Formik>

          </div>
          <div className="learning-progression-legend">
            {levels.map(level => <div key={level.id} style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              <div style={{ borderRadius: '10px', width: '18px', height: '7px', backgroundColor: level.color}}></div>
              <div style={{ color: '#333', fontSize: '14px' }}>{level.label}</div>
            </div>)}
          </div>
        </div>
        
        {data?.goals?.length > 0 && <div>
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: `${LABEL_WIDTH}px`}}>
              <div style={{ fontWeight: '600' }}>{t('common.common-core-standards')}</div>
            </div>
            <div style={{ position: 'relative', width: `calc(100% - ${LABEL_WIDTH}px)` }}>
              <div style={{ position: 'absolute', zIndex: 1, top: '-8px', left: '-35px' }}>
                <ChevronLeft color='primary' sx={{cursor: 'pointer', fontSize: '40px' }} onClick={() => {scrollLeft()}}/>
              </div>
              <div style={{ position: 'absolute', zIndex: 1, top: '-8px', right: '-25px' }}>
                <ChevronRight color='primary' sx={{cursor: 'pointer', fontSize: '40px' }} onClick={() => {scrollRight()}}/>
              </div>
              
              <div 
                style={{  
                  width: '100%', 
                  overflowX: 'hidden', 
                  scrollbarWidth: 'thin', 
                  paddingBottom: '10px',
                }}>
                
                <div style={{ 
                  position: 'relative', 
                  left: `${(-1)*scroll}px`, 
                  display: 'flex', 
                  width: `${data.students.length * CELL_WIDTH }px`,
                  transitionDuration: '500ms',
                  transitionProperty: 'left'
                  }}>

                  {data.students.map(s => <div key={s.id} style={{ width: `${CELL_WIDTH}px` }}>
                    {s.display_name}
                  </div>)}
                </div>

              </div>
            </div>

          </div>

          {data.goals.map( (g,idx) => <div key={idx} style={{ 
              display: 'flex', 
              width: '100%',
              alignItems: 'center', 
              paddingTop: '10px',
              paddingBottom: '10px',
              borderTop: '1px solid #ccc'
            }}>

              <div style={{ width: `${LABEL_WIDTH}px`, fontSize: '13px' }}>{g.display_name}</div>

              <div 
                style={{  
                  width: `calc(100% - ${LABEL_WIDTH}px)`, 
                  whiteSpace: 'nowrap', 
                  overflowX: 'hidden', 
                  scrollbarWidth: 'thin', 
                }}>
                
                <div style={{ 
                  position: 'relative', 
                  left: `${(-1)*scroll}px`, 
                  display: 'flex', 
                  width: `${data.students.length * CELL_WIDTH }px`,
                  transitionDuration: '500ms',
                  transitionProperty: 'left',
                  alignItems: 'center',
                  gap: '2px'
                  }}>
                    {g.students.map(s => <div key={s.id} style={{
                       width: `${CELL_WIDTH}px`,
                       background: levelColor(s.percentage),
                       height: '50px',
                       padding: '10px',
                    }}>
                    {s.percentage}%
                    </div>)}
                  </div>
              </div>
          </div>).slice((page-1)*PAGE_SIZE, page*PAGE_SIZE)}
      
                    
          {data.goals.length > PAGE_SIZE &&
              <div style={{
                borderTop: '1px solid #ccc',
                paddingTop: '10px',
                display: 'flex',
                width: '100%',
                justifyContent: 'center'
               }}>
               <Pagination
                  shape='rounded'
                  count={Math.ceil(data.goals.length / PAGE_SIZE)}
                  color='primary'
                  size='large'
                  sx={{ '& .Mui-selected': { color: '#000 !important' } }}
                  onChange={(e, pageNumber) => setPage(pageNumber)}
                />
              </div>}
        </div>}

      </Box>
  )
}

export default LearningProgression
